import { Spin } from 'antd';
import { SunburstChart } from '@components/charts';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface SunburstNode {
  name: string;
  value?: number;
  children?: SunburstNode[];
}
type Data = SunburstNode[];

function SunburstWidget({ instance }: WidgetRenderProps) {
  const { data, isLoading } = useWidgetData<Data>(
    instance.id, 'sunburst', instance.config as Record<string, unknown>, instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  return <SunburstChart data={data ?? []} />;
}

export const sunburstWidgetDef: WidgetDefinition = {
  type: 'sunburst',
  name: 'Sunburst Chart',
  description: 'Radial hierarchy',
  icon: 'HighlightOutlined',
  category: 'chart',
  defaultTitle: 'Sunburst',
  defaultConfig: {},
  minW: 4, minH: 5, defaultW: 5, defaultH: 7,
  component: SunburstWidget,
  settingsSchema: { fields: [] },
};
